import TWEEN from '@tweenjs/tween.js';

export async function tween(object: any, axis:string, value:number, time:number, delay = 0, onCompleteCallback:()=>void = ()=>{}, onUpdateCallback = ()=>{}) {
    try {
        let to = {};
        to[axis] = value;
        new TWEEN.Tween(object)
            .to(to, time)
            .easing(TWEEN.Easing.Quadratic.InOut)
            .onUpdate( onUpdateCallback )
            .onComplete( onCompleteCallback )
            .delay(delay)
            .start();
    } catch (e) {
        console.debug(e);
    }
}